<template>
  <div class="theme_details_wrap" v-if="detailsInfo!=null">
    <div class="theme_details_stem">
      <div class="theme_details_stem_title">
        <span v-if="detailsInfo.roofPlacement">顶</span>
        <h2 v-html="$replace.replaceMark(detailsInfo.theme)"></h2>
      </div>
      <div class="theme_details_stem_content ql-editor" v-html="detailsInfo.content"></div>
      <div class="theme_details_stem_info">
        <div class="theme_details_stem_info_left">
          <div class="left_box"><p>{{detailsInfo.anonymous==1?detailsInfo.userName:'匿名用户'}}</p></div>
          <div class="left_box"><p>{{detailsInfo.createTimeStr}}</p></div>
          <div class="left_box" v-if="detailsInfo.discussionAreaId!=3">
            <img src="../../../../../../../static/images/study/icon/zhangjie.png"/>
            <span>{{detailsInfo.catalogName&&detailsInfo.catalogName!=null?detailsInfo.catalogName:'全部教学章节'}}</span>
          </div>
        </div>
        <div class="theme_details_stem_info_right">
          <ol>
            <li @click="sameQuestion(detailsInfo)" :class="detailsInfo.isSameQuestion?'same_question_ck':''"><span>同问</span><span>{{(detailsInfo.sameQuestionNum&&detailsInfo.sameQuestionNum!=null)?detailsInfo.sameQuestionNum:0}}</span></li>
            <li @click="likedDiscuss(detailsInfo)" :class="detailsInfo.isPraise?'praise_ck':''"><i></i><span>{{(detailsInfo.praiseCount&&detailsInfo.praiseCount!=null)?detailsInfo.praiseCount:0}}</span></li>
            <!--<li class="edit_discuss" v-if="detailsInfo.isCreateUser"><i @click="editDiscuss(detailsInfo)"></i></li>-->
            <li class="delete_discuss" v-if="detailsInfo.isCreateUser||detailsInfo.isClassTeacher"><i @click="deleteDiscuss(detailsInfo)"></i></li>
          </ol>
        </div>
      </div>
      <div class="discuss_status" v-if="detailsInfo.repliedOrParticipation"><p>{{detailsInfo.repliedOrParticipationName}}</p></div>
    </div>
    <div class="reply_area_wrap">
      <el-input
        type="textarea"
        placeholder="欢迎留言交流" 
        maxlength="300" 
        show-word-limit
        v-model="replyValue" class="reply_area">
      </el-input>
      <el-checkbox v-model="isAnonymousReply" v-if="!isShowAnonymous">匿名发表</el-checkbox>
      <el-button :disabled="isReply" @click="publishReply(detailsInfo)">发表留言</el-button>
    </div>
    <div class="reply_area_list">
      <div class="reply_num">
        <span>全部回复</span>
        <span>{{replyList?replyList.length:0}}</span>
      </div>
      <div class="reply_list">
        <ul v-if="replyList.length>0">
          <li class="reply_list_lis" v-for="(item,key) in replyList" :key="key">
            <div class="reply_list_title">
              <p>{{item.deleteFlag==1?'该回复已删除':item.discussionContent}}</p>
            </div>
            <div class="reply_list_footer">
              <div class="reply_list_left">
                <span class="reply_name">{{item.anonymous==1?item.userName:'匿名用户'}}</span>
                <span class="reply_type" v-if="item.userType==0||item.userType==1">教师</span>
                <span class="reply_time">{{item.replyTimeStr}}</span>
              </div>
              <div class="reply_list_right">
                <ol>
                  <li @click="replyLiked(item)" :class="item.isPraise?'reply_liked_ck':'reply_liked'">
                    <i></i>
                    <span>{{item.praiseCount==null?0:item.praiseCount}}</span>
                  </li>
                  <li class="reply_comment" @click="replyComment(item)">
                    <i></i>
                    <span>{{item.replyNum}}</span>
                  </li>
                  <li class="reply_delete" @click="replyDelete(item)" v-if="item.deleteFlag==0&&(item.isCreateUser||item.teacherFlag)">
                    <i></i>
                  </li>
                </ol>
              </div>
            </div>
            <div :class="'comment_list_wrap '+item.className">
              <div class="comment_area_wrap" v-if="item.deleteFlag==0">
                <el-input
                  type="textarea"
                  placeholder="我来说几句" 
                  maxlength="300" 
                  show-word-limit
                  v-model="item.commentValue" 
                  @keyup.native="editComment(item)" class="comment_area">
                </el-input>
                <el-checkbox v-model="item.anonymousValue" v-if="!isShowAnonymous">匿名发表</el-checkbox>
                <el-button :disabled="(item.commentValue&&item.commentValue.trim()!='')?false:true" @click="publishComment(item)">发表评论</el-button>
                <div style="clear: both;border-bottom: 1px solid #E6E6E6;"></div>
              </div>
              <div class="comment_list">
                <ul>
                  <li class="comment_list_lis" v-for="(v,i) in item.pinglunList" :key="i">
                    <div class="comment_list_title">
                      <p>{{v.discussionContent}}</p>
                    </div>
                    <div class="comment_list_footer">
                      <div class="comment_list_left">
                        <span class="comment_name">{{v.anonymous==1?v.userName:'匿名用户'}}</span>
                        <span class="comment_type" v-if="v.userType==0||v.userType==1">教师</span>
                        <span class="comment_time">{{v.replyTimeStr}}</span>
                      </div>
                      <div class="comment_list_right">
                        <ol>
                          <li :class="v.isPraise?'comment_liked_ck':'comment_liked'" class="" @click="likedComment(v)">
                            <i></i>
                            <span>{{v.praiseCount}}</span>
                          </li>
                          <li class="comment_delete" @click="deleteComment(v,item)" v-if="v.isCreateUser||v.teacherFlag">
                            <i></i>
                          </li>
                        </ol>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
        <div v-else class="no_reply_list">
          <img src="../../../../../../../static/images/wujieguo.png"/>
          <p>暂无回复</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from "../../../../../../api/discussApi";
export default {
  data() {
    return {
      replyValue: '',
      isReply: true,
      isComment: true,
      themeContent: '',
      replyList:[],
      isAnonymousReply: false,
      detailsInfo: null,
      isShowAnonymous: (sessionStorage.getItem('userType')==0||sessionStorage.getItem('userType')==1)?true:false,
      sameQuestionFlag: true,
      likedDiscussFlag: true,
      likedCommentFlag: true,
      replyLikedFlag: true
    }
  },
  props: {
    region: {
      type: String,
      default: ''
    },
    detailsId: {
      type: Number,
      default: 0
    },
    classId: {
    	type: Number,
      default: 0
    }
  },
  watch: {
    replyValue: function(val){
      if(val!=''){
        this.isReply = false
      }else{
        this.isReply = true
      }
    },
    detailsInfo: function(val){
      // console.log(val)
    },
  },
  created() {
    
  },
  mounted() {
    this.getReplyList();
  },
  methods: {
    getReplyList(){
      let that = this
      let detailsObj = {
        id: that.detailsId,
        courseId:that.$route.query.courseId,
        classId:that.classId,
      }
      api.getReplyList(detailsObj).then(rs=>{
        if(rs.code==0){
          that.detailsInfo = rs.data
          this.replyList = []
          that.detailsInfo.learnToolReplies.forEach((v,i)=>{
            let replyObj = {
              anonymous: v.anonymous,
              deleteFlag: v.deleteFlag,
              discussionContent: that.$replace.replaceMark(v.discussionContent),
              id: v.id,
              isCreateUser: v.isCreateUser,
              isPraise: v.isPraise,
              praiseCount: v.praiseCount,
              replyNum: v.replyNum,
              replyTimeStr: v.replyTimeStr,
              teacherFlag: v.teacherFlag,
              userName: v.userName,
              userType: v.userType,
              className: '',
              anonymousValue: false,
              pinglunList: []
            }
            this.replyList.push(replyObj)
          })
        }else{
          that.$messageError(rs.msg)
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    sameQuestion(item){
      if(this.sameQuestionFlag){
        this.sameQuestionFlag = false
        item.isSameQuestion = !item.isSameQuestion
        let obj = {
          discussionId: item.id,
          isAdd: item.isSameQuestion
        }
        api.sameQuestion(obj).then(rs=>{
          if(rs.code==0){
            item.isSameQuestion?item.sameQuestionNum++:item.sameQuestionNum--
            this.sameQuestionFlag = true
          }else{
            this.$messageError(rs.msg)
            this.sameQuestionFlag = true
          }
        }).catch(err=>{
          console.log(err)
          this.sameQuestionFlag = true
        })
      }
    },
    likedDiscuss(item){
      if(this.likedDiscussFlag){
        this.likedDiscussFlag = false
        item.isPraise = !item.isPraise
        let obj = {
          learnId: item.id,
          isAdd: item.isPraise,
        }
        api.likedDiscuss(obj).then(rs=>{
          if(rs.code==0){
            item.isPraise?item.praiseCount++:item.praiseCount--
            this.likedDiscussFlag = true
          }else{
            this.$messageError(rs.msg)
            this.likedDiscussFlag = true
          }
        }).catch(err=>{
          console.log(err)
          this.likedDiscussFlag = true
        })
      }
    },
    editDiscuss(item){
      let obj = {
        router: '编辑讨论',
        region: item.discussionAreaId==2?'teacher':'student',
        item: item
      }
      this.$emit('changeRouter', obj)
    },
    deleteDiscuss(item){
      let tipsMsg = ''
      let tipsContent = ''
      let tipsSettings = {}
      let isDelete = false
      if(item.isClassTeacher){
        tipsMsg = '确定删除该主题吗？'
        tipsContent = '确定后将删除该回复下的全部评论'
        isDelete = true
      }else{
        if(item.replyCount>0){
          tipsMsg = '该主题已有回复，无法删除'
          tipsContent = '如需删除，请联系老师！'
          isDelete = false
          tipsSettings = {
            showCancelButton: false
          }
        }else{
          tipsMsg = '确定删除该主题吗？'
          tipsContent = ''
          isDelete = true
        }
      }
      this.$tipsDialog(
        "提示",
        tipsMsg,
        tipsContent,
        "el-icon-warning",
        "rgb(255, 178, 60)",
        tipsSettings
      ).then(() => {
        if(isDelete){
        	api.deleteDiscussion(item.id).then(rs=>{
            if(rs.code==0){
              this.$messageSuccess('删除成功')
              this.$parent.backBiscuss();
            }else{
              this.$messageError(rs.msg)
            }
          }).catch(err=>{
            console.log(err)
          })
        }else{
          console.log('无法删除')
        }
      }).catch(() => {
        console.log('cancel')
      });
    },
    publishReply(item){
      let that = this
      let obj = {
        learnId: item.id,
        type: 0,
        discussionContent: this.replyValue,
        anonymous: this.isAnonymousReply?0:1, // 0:匿名,1:非匿名
        courseId: this.$route.query.courseId,
        classId: this.classId,
        operationType: 2 // 1删除、2新增
      }
      api.publishDeleteReply(obj).then(rs=>{
        if(rs.code==0){
          let replyObj = {
            anonymous: rs.data.anonymous,
            deleteFlag: 0,
            discussionContent: that.$replace.replaceMark(rs.data.discussionContent),
            id: rs.data.id,
            isCreateUser: true,
            isPraise: rs.data.isPraise,
            praiseCount: 0,
            replyNum: 0,
            replyTimeStr: rs.data.replyTimeStr,
            teacherFlag: (rs.data.userType==0||rs.data.userType==1)?'教师':'学生',
            userName: rs.data.userName,
            userType: rs.data.userType,
            className: '',
            anonymousValue: false,
            pinglunList: []
          }
          this.replyList.unshift(replyObj)
        }
      }).catch(err=>{
        console.log(err)
      })
      
      this.replyValue = ''
    },
    editComment(item){
      let val = item.commentValue!=undefined ? item.commentValue.trim() : ''
      if(val!=''){
        item.isComment = false
      }else{
        item.isComment = true
      }
    },
    likedComment(item){
      if(this.likedCommentFlag){
        this.likedCommentFlag = false
        item.isPraise = !item.isPraise
        let obj = {
          learnId: this.detailsId,
          isAdd: item.isPraise,
          replyId: item.id
        }
        api.likedDiscuss(obj).then(rs=>{
          if(rs.code==0){
            item.isPraise?item.praiseCount++:item.praiseCount--
            this.likedCommentFlag = true
          }else{
            this.$messageError(rs.msg)
            this.likedCommentFlag = true
          }
        }).catch(err=>{
          console.log(err)
          this.likedCommentFlag = true
        })
      }
    },
    deleteComment(item,items){
      this.$tipsDialog(
        "提示",
        "确定删除该评论吗？",
        "",
        "el-icon-warning",
        "rgb(255, 178, 60)"
      ).then(() => {
        let obj = {
          id: item.id,
          learnId: this.detailsId,
          replyId: item.replyId,
          operationType: 1
        }
        api.deletePublishComment(obj).then(rs=>{
          if(rs.code==0){
            this.$messageSuccess('删除成功')
            this.getReplyList()
          }else{
            this.$messageError(rs.msg)
          }
        }).catch(err=>{
          console.log(err)
        })
      }).catch(() => {
        console.log('cancel')
      });
    },
    publishComment(item){
      let that = this
      let obj = {
        learnId: this.detailsId,
        type: 0,
        discussionContent: item.commentValue,
        replyId: item.id,
        anonymous: item.anonymousValue?0:1,
        courseId: this.$route.query.courseId,
        classId: this.classId,
        operationType: 2
      }
      api.deletePublishComment(obj).then(rs=>{
        if(rs.code==0){
          let commentObj = {
            anonymous: rs.data.anonymous,
            deleteFlag: rs.data.deleteFlag,
            discussionContent: that.$replace.replaceMark(rs.data.discussionContent),
            id: rs.data.id,
            isCreateUser: true,
            praiseCount: 0,
            replyId: rs.data.replyId,
            replyNum: 0,
            replyTimeStr: rs.data.replyTimeStr,
            teacherFlag: rs.data.teacherFlag,
            userName: rs.data.userName,
            userType: rs.data.userType,
          }
          item.pinglunList.unshift(commentObj)
          item.replyNum = item.replyNum+1
        }else{
          this.$messageError(rs.msg)
        }
        item.commentValue = ''
        item.anonymousValue = false
      }).catch(err=>{
        console.log(err)
      })
    },
    replyLiked(item){
      if(this.replyLikedFlag){
        this.replyLikedFlag = false
        if(item.deleteFlag==1){
          let str = item.isPraise?'该回复已删除，无法取消点赞':'该评论已删除，无法点赞'
          this.$messageWarning(str)
          this.replyLikedFlag = true
          return
        }
        item.isPraise = !item.isPraise
        let obj = {
          learnId: this.detailsId,
          isAdd: item.isPraise,
          replyId: item.id
        }
        api.likedDiscuss(obj).then(rs=>{
        	console.log(rs)
          if(rs.code==0){
            item.isPraise?item.praiseCount++:item.praiseCount--;
            console.log(item.praiseCount)
            this.replyLikedFlag = true
          }else{
            this.$messageError(rs.msg)
            this.replyLikedFlag = true
          }
        }).catch(err=>{
          console.log(err)
          this.replyLikedFlag = true
        })
      }
    },
    replyComment(item){
      if(item.deleteFlag==1&&item.replyNum==0){
        if(item.replyNum==0){
          this.$messageWarning('该回复下暂无可查看的评论');
        }
        return
      }
      let that = this
      let obj = {
        id: item.id,
        learnId: that.detailsId,
        classId: that.classId,
        courseId: that.$route.query.courseId
      }
      if(item.className==''){
        item.className = 'active';
        api.replyComment(obj).then(rs=>{
          if(rs.code==0){
            if(rs.data.length>0){
              item.pinglunList = []
              rs.data.forEach((v,i)=>{
                let commentObj = {
                  anonymous: v.anonymous,
                  deleteFlag: v.deleteFlag,
                  discussionContent: that.$replace.replaceMark(v.discussionContent),
                  id: v.id,
                  isCreateUser: v.isCreateUser,
                  isPraise: v.isPraise,
                  learnId: that.detailsId,
                  praiseCount: v.praiseCount,
                  replyId: item.id,
                  replyTimeStr: v.replyTimeStr,
                  teacherFlag: v.teacherFlag,
                  userName: v.userName,
                  userType: v.userType,
                  isComment: false
                }
                item.pinglunList.push(commentObj)
              })
            }else{
              item.pinglunList = []
            }
          }else{
            this.$messageError(rs.msg)
            item.pinglunList = []
          }
        }).catch(err=>{
          console.log(err)
        })
      }else{
        item.className = ''
      }
    },
    replyDelete(item){
      this.$tipsDialog(
        "提示",
        "确定删除该回复吗？",
        "",
        "el-icon-warning",
        "rgb(255, 178, 60)"
      ).then(() => {
        let obj = {
          id: item.id,
          learnId: this.detailsId,
          operationType: 1 // 1删除、2新增
        }
        api.publishDeleteReply(obj).then(rs=>{
          if(rs.code==0){
            this.$messageSuccess('删除成功')
            this.getReplyList()
          }else{
            this.$messageError(rs.msg)
          }
        }).catch(err=>{
          console.log(err)
        })
      }).catch(() => {
        console.log('cancel')
      });
    }
  },
}
</script>
<style lang="scss">
  .theme_details_wrap{
    height: calc(100% - 48px);
    padding: 0 24px;
    box-sizing: border-box;
    overflow-y: auto;
    .theme_details_stem{
      width:100%;
      height:auto;
      background:rgba(255,255,255,1);
      border:1px solid rgba(230,230,230,1);
      opacity:1;
      border-radius:4px;
      margin-top: 12px;
      margin-bottom: 16px;
      position: relative;
      .theme_details_stem_title{
        display: flex;
        align-items: center;
        margin-top: 16px;
        padding: 0 24px;
        box-sizing: border-box;
        span{
          width: 18px;
          line-height: 18px;
          background: #F43D3D;
          font-size:12px;
          font-weight:400;
          color:rgba(255,255,255,1);
          text-align: center;
          margin-right: 6px;
        }
        h2{
          width: calc(100% - 100px);
          font-size:16px;
          font-weight:normal;
          color:rgba(51,51,51,1);
          word-break: break-all;
        }
      }
      .theme_details_stem_content{
        font-size:14px;
        font-weight:400;
        line-height: 18px;
        color:rgba(51,51,51,1);
        margin: 12px 0;
        padding: 0 24px;
        box-sizing: border-box;
        word-break: break-all;
        img{
          max-width: 100%;
        }
      }
      .theme_details_stem_info{
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-left: 24px;
        box-sizing: border-box;
        .theme_details_stem_info_left{
          display: flex;
          align-items: center;
          .left_box{
            display: flex;
            align-items: center;
            &:nth-child(2){
              margin: 0 40px;
            }
            p{
              font-size:14px;
              font-weight:400;
              color:rgba(153,153,153,1);
            }
            img{
              width: 14px;
              margin-right: 6px;
            }
            span{
              font-size:12px;
              font-weight:400;
              color:rgba(153,153,153,1);
            }
          }
        }
        .theme_details_stem_info_right{
          ol{
            display: flex;
            align-items: center;
            margin-right: 4px;
            li{
              border-left: 1px solid #E6E6E6;
              line-height: 12px;
              padding: 0 20px;
              cursor: pointer;
              i{
                display: inline-block;
                width: 14px;
                height: 14px;
              }
              span{
                font-size:12px;
                font-weight:400;
                color:rgba(153,153,153,1);
                margin-left: 6px;
              }
              &:first-child{
                border-left: none;
                // &:hover{
                //   span{
                //     color: #5397F7;
                //   }
                // }
              }
              &:nth-child(2){
                i{
                  background: url('../../../../../../../static/images/study/icon/dianzan_hv.png') no-repeat;
                  background-size: 100%;
                }
                // &:hover{
                //   i{
                //     background: url('../../../../../../../static/images/study/icon/dianzan.png') no-repeat;
                //     background-size: 100%;
                //   }
                //   span{
                //     color: #5397F7;
                //   }
                // }
              }
            }
            .edit_discuss{
              i{
                background: url('../../../../../../../static/images/study/icon/bianji_hv.png') no-repeat;
                background-size: 100%;
              }
              &:hover{
                i{
                  background: url('../../../../../../../static/images/study/icon/bianji.png') no-repeat;
                  background-size: 100%;
                }
                span{
                  color: #5397F7;
                }
              }
            }
            .delete_discuss{
              i{
                background: url('../../../../../../../static/images/study/icon/shanchu_hv.png') no-repeat;
                background-size: 100%;
              }
              &:hover{
                i{
                  background: url('../../../../../../../static/images/study/icon/shanchu.png') no-repeat;
                  background-size: 100%;
                }
                span{
                  color: #5397F7;
                }
              }
            }
            .same_question_ck{
              span{
                color: #5397F7;
              }
            }
            .praise_ck{
              i{
                background: url('../../../../../../../static/images/study/icon/dianzan.png') no-repeat !important;
                background-size: 100% !important;
              }
              span{
                color: #5397F7;
              }
            }
          }
        }
      }
      .discuss_status{
        position: absolute;
        right: 24px;
        top: 16px;
        p{
          font-size:12px;
          font-weight:400;
          color:rgba(83,151,247,1);
          padding: 3px 6px;
          border:1px solid rgba(83,151,247,1);
          border-radius:2px;
        }
      }
    }
    .reply_area_wrap{
      width: 100%;
      min-height: 100px;
      .reply_area{
        border-radius:4px;
        .el-textarea__inner{
          resize: none;
          max-height: 84px;
          background: #fff;
          border:1px solid rgba(230,230,230,1);
          &:focus{
            background: #fff;
          }
        }
      }
      .el-checkbox{
        margin-top: 12px;
      }
      button{
        padding: 0;
        width:72px;
        height:30px;
        border-radius:4px;
        background:rgba(255,255,255,1);
        border:1px solid rgba(83,151,247,1);
        font-size:12px;
        font-weight:400;
        color:rgba(83,151,247,1);
        float: right;
        margin-top:12px;
      }
      .el-button.is-disabled{
        background:rgba(230,230,230,1);
        color: #999999;
        border: none;
      }
    }
    .reply_area_list{
      .reply_num{
        margin: 16px 0;
        border-bottom: 1px solid #E6E6E6;
        padding-bottom: 24px;
        span{
          &:first-child{
            font-size:14px;
            font-weight:400;
            color:rgba(51,51,51,1);
          }
          &:last-child{
            font-size:14px;
            font-weight:400;
            color:rgba(153,153,153,1);
            margin-left: 10px;
          }
        }
      }
      .reply_list{
        ul{
          margin-bottom: 16px;
          .reply_list_lis{
            border-bottom: 1px solid #E6E6E6;
            margin-bottom: 16px;
            .reply_list_title{
              font-size:14px;
              font-weight:400;
              color:rgba(51,51,51,1);
              word-break: break-all;
            }
            .reply_list_footer{
              display: flex;
              justify-content: space-between;
              align-items: center;
              min-height: 46px;
              .reply_list_left{
                .reply_name{
                  font-size:14px;
                  font-weight:400;
                  color:rgba(153,153,153,1);
                }
                .reply_type{
                  font-size:12px;
                  font-weight:400;
                  color:rgba(83,151,247,1);
                  background: #E8F2FF;
                  padding: 3px 6px;
                  margin-left: 8px;
                }
                .reply_time{
                  font-size:12px;
                  font-weight:400;
                  color:rgba(153,153,153,1);
                  margin-left: 40px;
                }
              }
              .reply_list_right{
                ol{
                  display: flex;
                  li{
                    cursor: pointer;
                    padding: 0 24px;
                    border-left: 1px solid #E6E6E6;
                    line-height: 12px;
                    display: flex;
                    align-items: center;
                    i{
                      width: 14px;
                      height: 14px;
                      display: inline-block;
                    }
                    span{
                      font-size:12px;
                      font-weight:400;
                      color:rgba(153,153,153,1);
                      margin-left: 6px;
                    }
                  }
                  .reply_liked{
                    border-left: none;
                    i{
                      background: url('../../../../../../../static/images/study/icon/dianzan_hv.png') no-repeat;
                      background-size: 100%;
                    }
                    &:hover{
                      i{
                        background: url('../../../../../../../static/images/study/icon/dianzan.png') no-repeat;
                        background-size: 100%;
                      }
                      span{
                        color: #5397F7;
                      }
                    }
                  }
                  .reply_liked_ck{
                    border-left: none;
                    i{
                      background: url('../../../../../../../static/images/study/icon/dianzan.png') no-repeat;
                      background-size: 100%;
                    }
                    span{
                      color: #5397F7;
                    }
                  }
                  .reply_comment{
                    i{
                      background: url('../../../../../../../static/images/study/icon/pinglun_hv.png') no-repeat;
                      background-size: 100%;
                    }
                    &:hover{
                      i{
                        background: url('../../../../../../../static/images/study/icon/pinglun.png') no-repeat;
                        background-size: 100%;
                      }
                      span{
                        color: #5397F7;
                      }
                    }
                  }
                  .reply_delete{
                    i{
                      background: url('../../../../../../../static/images/study/icon/shanchu_hv.png') no-repeat;
                      background-size: 100%;
                    }
                    &:hover{
                      i{
                        background: url('../../../../../../../static/images/study/icon/shanchu.png') no-repeat;
                        background-size: 100%;
                      }
                    }
                  }
                }
              } 
            }
            .comment_list_wrap{
              width:100%;
              height: 0;
              background:rgba(244,244,244,1);
              position: relative;
              overflow: hidden;
              &::after,&::before{
                position:absolute;  
                content:'';
                border:10px solid;
              }
              &::before{  
                right: 100px;
                top: -20px;
                border-color: transparent transparent #E6E6E6 transparent ;
              }
              &::after{  
                border-color: transparent transparent #F4F4F4 transparent ;
                right: 100px;
                top: -18px;
              }
              .comment_area_wrap{
                padding: 0 16px;
                .comment_area{
                  width: 100%;
                  border-radius:4px;
                  margin: 12px 0;
                  .el-textarea__inner{
                    resize: none;
                    max-height: 84px;
                    background: #fff;
                    border:1px solid rgba(230,230,230,1);
                    font-size:12px;
                    font-weight:400;
                    color:rgba(153,153,153,1);
                    &:focus{
                      background: #fff;
                    }
                  }
                }
                button{
                  padding: 0;
                  width:72px;
                  height:30px;
                  border-radius:4px;
                  background:rgba(255,255,255,1);
                  border:1px solid rgba(83,151,247,1);
                  font-size:12px;
                  font-weight:400;
                  color:rgba(83,151,247,1);
                  float: right;
                  margin-bottom: 16px;
                }
                .el-button.is-disabled{
                  background:rgba(230,230,230,1);
                  color: #999999;
                  border: none;
                }
              }
              .comment_list{
                margin-top: 16px;
                ul{
                  padding: 0 16px;
                  margin: 0;
                  .comment_list_lis{
                    border-bottom: 1px solid #E6E6E6;
                    .comment_list_title{
                      font-size:14px;
                      font-weight:400;
                      color:rgba(51,51,51,1);
                      margin-top: 16px;
                      word-break: break-all;
                    }
                    .comment_list_footer{
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      min-height: 46px;
                      .comment_list_left{
                        .comment_name{
                          font-size:14px;
                          font-weight:400;
                          color:rgba(153,153,153,1);
                        }
                        .comment_type{
                          font-size:12px;
                          font-weight:400;
                          color:rgba(83,151,247,1);
                          background: #E8F2FF;
                          padding: 3px 6px;
                          margin-left: 8px;
                        }
                        .comment_time{
                          font-size:12px;
                          font-weight:400;
                          color:rgba(153,153,153,1);
                          margin-left: 40px;
                        }
                      }
                      .comment_list_right{
                        ol{
                          display: flex;
                          li{
                            cursor: pointer;
                            padding: 0 24px;
                            border-left: 1px solid #E6E6E6;
                            line-height: 12px;
                            display: flex;
                            align-items: center;
                            i{
                              width: 14px;
                              height: 14px;
                              display: inline-block;
                            }
                            span{
                              font-size:12px;
                              font-weight:400;
                              color:rgba(153,153,153,1);
                              margin-left: 6px;
                            }
                          }
                          .comment_liked{
                            border-left: none;
                            i{
                              background: url('../../../../../../../static/images/study/icon/dianzan_hv.png') no-repeat;
                              background-size: 100%;
                            }
                            &:hover{
                              i{
                                background: url('../../../../../../../static/images/study/icon/dianzan.png') no-repeat;
                                background-size: 100%;
                              }
                              span{
                                color: #5397F7;
                              }
                            }
                          }
                          .comment_liked_ck{
                            border-left: none;
                            i{
                              background: url('../../../../../../../static/images/study/icon/dianzan.png') no-repeat;
                              background-size: 100%;
                            }
                            span{
                              color: #5397F7;
                            }
                          }
                          .comment_comment{
                            i{
                              background: url('../../../../../../../static/images/study/icon/pinglun_hv.png') no-repeat;
                              background-size: 100%;
                            }
                            &:hover{
                              i{
                                background: url('../../../../../../../static/images/study/icon/pinglun.png') no-repeat;
                                background-size: 100%;
                              }
                              span{
                                color: #5397F7;
                              }
                            }
                          }
                          .comment_delete{
                            i{
                              background: url('../../../../../../../static/images/study/icon/shanchu_hv.png') no-repeat;
                              background-size: 100%;
                            }
                            &:hover{
                              i{
                                background: url('../../../../../../../static/images/study/icon/shanchu.png') no-repeat;
                                background-size: 100%;
                              }
                            }
                          }
                        }
                      } 
                    }
                  }
                }
              }
            }
            .comment_list_wrap.active{
              height: auto;
              border:1px solid rgba(230,230,230,1);
              margin-top: 10px;
              margin-bottom: 16px;
            }
          }
        }
        .no_reply_list{
          text-align: center;
          img{
            width: 120px;
            margin: 10px 0 10px;
          }
        }
      }
    } 
  }
</style>


// WEBPACK FOOTER //
// src/components/views/TeachClass/components/discuss/component/themeDetails.vue